/**
 * Constants for intake list filtering
 */

// Filter status values used in the intake list page
export const INTAKE_LIST_STATUS = {
  ACTIVE: "ACTIVE",
  ARCHIVED: "ARCHIVED",
  COMPLETED: "COMPLETED",
};

// Default status for intake list filters
export const DEFAULT_INTAKE_LIST_STATUS = INTAKE_LIST_STATUS.ACTIVE;
